export const CYCLES_LIST_PATH = "/settings/features/performance-reviews/review-cycles";

const ORG_CYCLES_LIST_PATH = "/org/review-cycles";

export type CycleDetailOrigin = "settings" | "home" | "org";

export type CycleManagementOrigin = Extract<CycleDetailOrigin, "settings" | "org">;

const SEGMENT_BY_ORIGIN = {
    settings: "/review-cycles/:cycleId",
    home: "/home/review-cycles/:cycleId",
    org: `${ORG_CYCLES_LIST_PATH}/:cycleId`
} as const satisfies Record<CycleDetailOrigin, string>;

export function cycleDetailAreaSegment(origin: CycleDetailOrigin): string {
    return SEGMENT_BY_ORIGIN[origin];
}

const ORIGIN_PATH = {
    settings: CYCLES_LIST_PATH,
    home: "/",
    org: ORG_CYCLES_LIST_PATH
} as const satisfies Record<CycleDetailOrigin, string>;

export function cycleOriginPath(origin: CycleDetailOrigin): string {
    return ORIGIN_PATH[origin];
}

export function cycleManagementOrigin(isNavigationRedesign: boolean): CycleManagementOrigin {
    return isNavigationRedesign ? "org" : "settings";
}

export function buildCycleDetailPath(origin: CycleDetailOrigin, cycleId: string): string {
    return SEGMENT_BY_ORIGIN[origin].replace(":cycleId", cycleId);
}

export function cycleBuilderAreaSegment(origin: CycleDetailOrigin): string {
    return `${SEGMENT_BY_ORIGIN[origin]}/edit`;
}

export function buildCycleBuilderPath(origin: CycleDetailOrigin, cycleId: string): string {
    return cycleBuilderAreaSegment(origin).replace(":cycleId", cycleId);
}

export function cycleConfigurationAreaSegment(origin: CycleDetailOrigin): string {
    return `${SEGMENT_BY_ORIGIN[origin]}/configuration`;
}

export function buildCycleConfigurationPath(origin: CycleDetailOrigin, cycleId: string): string {
    return cycleConfigurationAreaSegment(origin).replace(":cycleId", cycleId);
}

export function cycleCreateAreaSegment(origin: CycleDetailOrigin): string {
    return SEGMENT_BY_ORIGIN[origin].replace(":cycleId", "new");
}
